import { connect } from "react-redux";
import * as applicationActions from "./actions";
import { get_row_additional_data_bisnode } from "./actions";
import * as usersActions from "../users/actions";

function mapStateToProps(state) {
  return {
    applications: state.applications.preApplications,
    accountInfos: state.users.accountInfos,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    getApplications: () => {
      dispatch(applicationActions.get_pre_applications());
    },

    changeApplicationListPage: (page) => {
      dispatch(applicationActions.change_pre_application_list_page(page));
    },

    changeApplicationListFilter: (type, key, value) => {
      dispatch(
        applicationActions.change_pre_application_list_filter(key, value),
      );
    },

    getRowAdditionalData: (accountId, identity, bankAccountId, Id) => {
      dispatch(usersActions.get_user_data_for_account_id(accountId));
      dispatch(get_row_additional_data_bisnode(accountId, Id));
    },

    getAccountInfoForId: (accountId) => {
      dispatch(usersActions.get_user_data_for_account_id(accountId));
    },

    setRiskBasedOffer: (applicationId, accountId, data) => {
      let postData = {
        ApplicationId: applicationId,
        AccountId: accountId,
        ...data,
      };

      dispatch(applicationActions.set_risk_offer(postData));
    },

    setNominalBasedOffer: (applicationId, accountId, data) => {
      let postData = {
        ApplicationId: applicationId,
        AccountId: accountId,
        ...data,
      };

      dispatch(applicationActions.set_nominal_offer(postData));
    },
  };
}

export const preApplicationsConnector = connect(
  mapStateToProps,
  mapDispatchToProps,
);
